import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/api";
import { Section, Overline } from "@/components/Primitives";
import { Star, ExternalLink } from "lucide-react";

export default function Reviews() {
  const { t, i18n } = useTranslation();
  const [reviews, setReviews] = useState([]);
  const lang = i18n.language;

  useEffect(() => {
    api.get("/reviews").then(r => setReviews(r.data || []));
  }, []);

  const tx = (obj) => obj?.[lang] || obj?.fr || "";

  return (
    <div data-testid="reviews-page" className="pt-32">
      <Section testId="reviews-header">
        <Overline>{t("reviews_page.overline")}</Overline>
        <h1 className="font-serif-luxe text-5xl sm:text-6xl font-light tracking-tight text-[#F8F5EF] mt-3 mb-6">{t("reviews_page.title")}</h1>
        <p className="max-w-3xl text-[#F8F5EF]/70 leading-relaxed mb-8">{t("reviews_page.intro")}</p>
        <a href="https://search.google.com/local/writereview?placeid=" target="_blank" rel="noreferrer" className="btn-ghost-gold inline-flex" data-testid="google-review-btn">
          {t("reviews_page.google_btn")} <ExternalLink size={14} />
        </a>
      </Section>

      <Section testId="reviews-list" className="!pt-0">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r, idx) => (
            <div key={r.id} className="luxe-card p-8" data-testid={`reviews-card-${idx}`}>
              <div className="flex gap-1 mb-4">
                {Array.from({ length: r.rating }).map((_, i) => <Star key={i} size={14} className="fill-[#D4AF37] text-[#D4AF37]" />)}
              </div>
              <p className="text-[#F8F5EF]/85 italic leading-relaxed font-serif-luxe text-lg">"{tx(r.comment)}"</p>
              <div className="mt-6 pt-4 border-t border-[#D4AF37]/15 flex items-center justify-between">
                <span className="text-sm text-[#F8F5EF]/80">{r.author}</span>
                <span className="text-[10px] tracking-[0.2em] uppercase text-[#D4AF37]">{r.source}</span>
              </div>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}
